type LookupOption = { code: string; label?: string; labelI18n?: Record<string, string> | null };

/**
 * lookup 字典标签按界面语言取值 —— 所有字典显示点的唯一规则（2026-09-26 review MEDIUM）。
 *
 * 非英文界面且 `labelI18n[locale]` 有值 → 用它；英文界面、或缺当前语种 → 一律回落规范 `label`。
 *
 * 刻意不用 pickI18n：它在英文界面（以及 pt/es 缺译时）取 `labelI18n.en`，而字典里 en 译文和规范
 * label 并不总一致 —— intent_priority_type 的 label "Urgent"、labelI18n.en "Urgent Priority"，
 * task_subcategory「Guest Communication → Guest Comm」，task_status_type on_hold「On-hold → On Hold」。
 * 走 pickI18n 英文界面的现有文案会被悄悄改掉，pt/es 缺译时还会显示这串英文。
 * pickI18n 本身不动：菜单 / 角色 / 视图等依赖「labelI18n.en 覆盖基名」的调用方照旧。
 */
export function pickLookupLabel(
  labelI18n: Record<string, string> | null | undefined,
  locale: string | undefined,
  label: string,
): string {
  if (!locale || locale === 'en') return label;
  const localized = labelI18n?.[locale];
  return typeof localized === 'string' && localized.length > 0 ? localized : label;
}

/**
 * 字典选项（需带 includeExtra 拉回的 labelI18n）→ 按当前语言替换 label。
 * 筛选下拉的 optionsToSchema 只读 label，不做这一步就永远是英文。
 */
export function localizeLookupOptions<T extends LookupOption>(
  options: T[] | null | undefined,
  locale: string,
): Array<T & { label: string }> {
  return (options ?? []).map((o) => ({ ...o, label: pickLookupLabel(o.labelI18n, locale, o.label ?? o.code) }));
}
